import {useTranslation} from "react-i18next";
import {Text, ThemeIcon} from "@mantine/core";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {CanceledTimelineEvent} from "@ots-frontend/ots-data";
import {IconCircleXFilled} from "@tabler/icons-react";

type Props = {
    event: CanceledTimelineEvent;
};

export const CanceledTimelineItemTitle = (props: {}) => {
    const {t} = useTranslation(["common"])
    return <>{t("common.entity.dispatchrequest.timeline.canceled.title", "Canceled")}</>
}

export const CanceledTimelineItemBullet = (props: {}) => {
    return (
        <ThemeIcon
            size={22}
            color="dispatch-request-canceled"
            radius="xl"
        >
            <IconCircleXFilled size={12}/>
        </ThemeIcon>
    )
}

export const CanceledTimelineItem = (props: Props) => {
    const {event} = props;

    const {t} = useTranslation(["common"])

    return (
        <>
            <Text color="dimmed" size="sm">
                {t("common.entity.dispatchrequest.timeline.canceled.summary", "{{personName}} canceled the dispatch request.", {
                    personName: event.person ? event.person : t("common.shared.user", "User")
                })}
            </Text>

            <Text size="xs" mt={4}>
                <FormattedDateTime date={event.date}/>
            </Text>
        </>
    );
};

CanceledTimelineItem.Title = CanceledTimelineItemTitle
CanceledTimelineItem.Bullet = CanceledTimelineItemBullet;
